import { useState } from 'react';
import logo from 'assets/images/logo-title.svg';
import { useUserData } from 'commons/contexts';
import { useSearch } from 'commons/contexts/SearchContext/useSearch';
import { Header as HeaderRoot } from '../DSHeader/Header';
import { Person, Search } from '@mui/icons-material';
import { IconButton, TextField, Box } from '@mui/material';
import { styled } from '@stitches/react';

interface IHeaderProps {
  showSearchInput?: boolean;
}

const SearchContainer = styled(Box, {
  display: 'flex',
  alignItems: 'center',
  transition: 'width 0.3s ease, border-bottom 0.3s ease',
  width: '30px',
  borderBottom: '0px solid transparent',
  '&.open': {
    width: '300px',
    borderBottom: '1px solid white',
  },
});

export const Header = ({ showSearchInput }: IHeaderProps) => {
  const { searchTerm, setSearchTerm } = useSearch();
  const { user } = useUserData();
  const [isSearchOpen, setIsSearchOpen] = useState(!!searchTerm);

  const handleSearchClick = () => {
    setIsSearchOpen(true);
  };

  const handleBlur = () => {
    if (searchTerm) {
      return;
    }
    setIsSearchOpen(false);
  };

  const searchInput = (
    <SearchContainer className={isSearchOpen ? 'open' : ''}>
      <IconButton onClick={handleSearchClick} aria-label="search" size="small">
        <Search sx={{ color: 'white' }} />
      </IconButton>
      {isSearchOpen && (
        <TextField
          variant="standard"
          type="text"
          value={searchTerm}
          onChange={e => setSearchTerm(e.target.value)}
          placeholder="Busca..."
          onBlur={handleBlur}
          autoFocus
          fullWidth
          InputProps={{ disableUnderline: true }}
          defaultValue="Small"
          size="small"
          sx={{
            '& .MuiInputBase-root': {
              color: 'white',
            },
          }}
        />
      )}
    </SearchContainer>
  );

  return (
    <HeaderRoot
      showSearchInput={showSearchInput}
      logo={<img src={logo} alt="App Logo" />}
      searchComponent={searchInput}
      userAvatar={<Person sx={{ color: 'white' }} />}
      userName={user.user.fullName}
    />
  );
};
